import { Badge, Box, Checkbox, Collapse, Flex, Icon, Link, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { EspdCriterionDto } from "../../../../../autogen/bff-api";

interface Props {
  criterion: EspdCriterionDto;
  isSelected: boolean;
  onToggle: (id: string, selected: boolean) => void;
}

export const EspdCriterionCard = ({ criterion, isSelected, onToggle }: Props) => {
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const isNorwegian = i18n.language === "no" || i18n.language === "nb";
  const displayName = isNorwegian && criterion.nameNorwegian ? criterion.nameNorwegian : criterion.name;
  const displayDescription =
    isNorwegian && criterion.descriptionNorwegian ? criterion.descriptionNorwegian : criterion.description;

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="md" p="3" mb="2" bg="gray.50">
      <Flex alignItems="start" gap="2">
        <Checkbox
          isChecked={isSelected || criterion.required}
          isDisabled={criterion.required}
          onChange={(e) => onToggle(criterion.id, e.target.checked)}
          mt="1"
          colorScheme="teal"
        />
        <Box flex="1">
          <Flex alignItems="center" gap="2" cursor="pointer" onClick={() => setExpanded(!expanded)}>
            <Icon as={expanded ? FaChevronDown : FaChevronRight} w="10px" h="10px" color="smMuted" />
            <Text fontWeight="medium" fontSize="sm">
              {displayName}
              {criterion.required && (
                <Badge colorScheme="red" fontSize="xs" ml="2">
                  {t("Required")}
                </Badge>
              )}
            </Text>
          </Flex>
          <Collapse in={expanded}>
            <Box mt="2" ml="5">
              <Text fontSize="xs" color="smMuted">
                {displayDescription}
              </Text>
              {criterion.legislationTitle && (
                <Text fontSize="xs" color="smMuted" mt="1">
                  {criterion.legislationTitle}
                  {criterion.legislationArticle && `, Art. ${criterion.legislationArticle}`}
                  {criterion.legislationUri && (
                    <>
                      {" — "}
                      <Link href={criterion.legislationUri} isExternal color="teal.500" fontSize="xs">
                        {t("View legislation")}
                      </Link>
                    </>
                  )}
                </Text>
              )}
            </Box>
          </Collapse>
        </Box>
      </Flex>
    </Box>
  );
};
